import React from "react";
import { useGeolocated } from "react-geolocated";
import { useI18n } from "../i18n/LanguageContext";

const LocationComponent = () => {
  const { t } = useI18n();
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
    });

  return !isGeolocationAvailable ? (
    <div>{t("location.unsupported")}</div>
  ) : !isGeolocationEnabled ? (
    <div>{t("location.disabled")}</div>
  ) : coords ? (
    <table>
      <tbody>
        <tr>
          <td>{t("location.lat")}</td>
          <td>{coords.latitude}</td>
        </tr>
        <tr>
          <td>{t("location.lng")}</td>
          <td>{coords.longitude}</td>
        </tr>
      </tbody>
    </table>
  ) : (
    <div>{t("location.getting")}</div>
  );
};

export default LocationComponent;
